import { createContext } from 'react';
import { Env } from '../typings';

export type ContextProps = {
  mfer: any;
};

export type ShellProps = {
  config: any;
  env: Env;
};

const ApplicationContext = createContext<ContextProps>({ mfer: {} });

export default ApplicationContext;
